import { useSetAtom } from 'jotai';

import { type AtomState } from '@/ui/utilities/state/jotai/types/AtomState';

export const useSetAtomState = <TValue>(state: AtomState<TValue>) =>
  useSetAtom(state.atom);
